/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type CreateSignedChatAttachmentURLForm2 = {
  /**
   * The ID of the chat attachment
   */
  id: string;
  /**
   * The project ID that the attachment belongs to
   */
  projectId: string;
  /**
   * Time-to-live in seconds (default: 600, max: 3600)
   */
  ttlSeconds?: number | undefined;
};

/** @internal */
export type CreateSignedChatAttachmentURLForm2$Outbound = {
  id: string;
  project_id: string;
  ttl_seconds?: number | undefined;
};

/** @internal */
export const CreateSignedChatAttachmentURLForm2$outboundSchema: z.ZodMiniType<
  CreateSignedChatAttachmentURLForm2$Outbound,
  CreateSignedChatAttachmentURLForm2
> = z.pipe(
  z.object({
    id: z.string(),
    projectId: z.string(),
    ttlSeconds: z.optional(z.int()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectId: "project_id",
      ttlSeconds: "ttl_seconds",
    });
  }),
);

export function createSignedChatAttachmentURLForm2ToJSON(
  createSignedChatAttachmentURLForm2: CreateSignedChatAttachmentURLForm2,
): string {
  return JSON.stringify(
    CreateSignedChatAttachmentURLForm2$outboundSchema.parse(
      createSignedChatAttachmentURLForm2,
    ),
  );
}
